import React, { useState } from 'react';
import axios from 'axios';
import api from './axiosConfig';
import './Login.css';

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const userGuid = localStorage.getItem('user_guid') || null;
      const response = await axios.post(`${apiUrl}/api/login`, {
        email,
        password,
        user_guid: userGuid
      });

      if (response.data.success) {
        // Store login state in localStorage
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userFirstName', response.data.firstName || '');
        
        // Store JWT token
        if (response.data.access_token) {
          localStorage.setItem('jwt_token', response.data.access_token);
        }
        
        // Store user_guid if provided
        if (response.data.user_guid) {
          localStorage.setItem('user_guid', response.data.user_guid);
        }
        
        // Call the success callback to redirect to main app
        onLoginSuccess(response.data.firstName || '', response.data.user_guid);
      } else {
        setError(response.data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error.message || 'Authentication failed');
      setError('Login failed. Please check your credentials and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="rejara-logo">
            <img 
              src="data:image/svg+xml,%3csvg%20width='81'%20height='81'%20viewBox='0%200%2081%2081'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='40.1228'%20cy='40.5273'%20r='40'%20fill='%233A6D8C'/%3e%3cpath%20d='M32.2033%2036.1175C27.3364%2036.1175%2023.3898%2040.0641%2023.3898%2044.9341H48.0393C52.9093%2044.9341%2056.8559%2040.9875%2056.8559%2036.1175H32.2033ZM48.0393%2048.3774H37.972C37.972%2050.8108%2038.9571%2053.0157%2040.5537%2054.6123C42.1471%2056.2058%2044.3521%2057.194%2046.7855%2057.194H56.8559C56.8559%2052.324%2052.9093%2048.3774%2048.0393%2048.3774ZM56.8559%2032.6742H32.2033C27.3364%2032.6742%2023.3898%2028.7276%2023.3898%2023.8607H48.0393C52.9093%2023.8607%2056.8559%2027.8073%2056.8559%2032.6742Z'%20fill='white'/%3e%3c/svg%3e"
              alt="Rejara Logo"
              className="logo-svg"
            />
            <h1>Rejara</h1>
          </div>
          <p className="login-subtitle">Caregiving Recommendations Platform</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              <i className="fas fa-exclamation-circle"></i>
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Signing In...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i>
                Sign In
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>Welcome to Rejara - Your AI-powered caregiving companion<br/>Copyright © 2025</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
